import RestClient from './rest-client'

export default class UserServiceAmount extends RestClient {
  static urlForUser(userId) {
    return this.apiUrl + `/users/${userId}/user_service_amounts`
  }

  static get paramKey () {
    return 'user_service_amount'
  }

  // Fetch all user_service_amounts for a user
  static async allForUser (userId) {
    const { data } = await this._get(this.urlForUser(userId))
    if (Array.isArray(data.data)) {
      return data.data.map(o => new this(o))
    } else {
      return []
    }
  }

  // Fetch a user_service_amount for a user and service
  static async findByUserAndService (userId, serviceId) {
    const { data } = await this._get(this.urlForUser(userId), { service_id: serviceId })
    if (Array.isArray(data.data) && data.data.length > 0) {
      return new this(data.data[0])
    } else {
      return null
    }
  }

  // Create for a user
  static async createForUser(userId, payload) {
    const { data } = await this._post(this.urlForUser(userId), { [this.paramKey]: payload })
    return new this(data.data)
  }

  // Create or update (if id exists)
  async save (userId) {
    if (this.id) {
      return this.update(userId)
    } else {
      return this.constructor.createForUser(userId, this)
    }
  }
} 